<template>
    <div class="row">
        <div class="col-lg-8 col-md-10 ml-auto mr-auto">
            <div class="section-title-wrapper text-center section-space--mb_50 wow move-up">
                <h2 class="section-title font-width-bold">Get in Touch!</h2>
            </div>
            <!-- newsletter form -->
            <div class="newsletter-form--two section-space--mb_40 text-center wow move-up">
                <a href="mailto:roberto.baldizon@silibrain.com"><button class="ht-btn ht-btn-md">Message Us</button></a>
            </div>
            <!-- newsletter text -->
            <h6 class="sub-heading text-center wow move-up"></h6>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'newsletterTwo'
    }
</script>